<template>
  <div class="orderDetail">
      <div class="banxin">
          <div class="head">
              <router-link to="/myOrder">
                <div class="mar-right-10">我的订单</div>
              </router-link>
            <div class='arrow'></div>
            <div class="mar-right-10">订单详情</div>
          </div>
          <div class="status">
              <div class="left">
                <p class="fs16 fw-blod mar-top-20 mar-bot-60">订单号：{{orderDetail.orderFormid}}</p>
                <!-- <div class="groupShopping">
                  <div class="groupShopTit">等待成团</div>
                  <span @click="inviteFriends">邀请好友</span>
                  <span class="closeOrder" @click="closeOrder">取消订单</span>
                </div> -->
                <div class="box" v-if="orderDetail.state==1">
                     <p class="fs24 fw-blod mar-bot-10 font-color-71B">等待付款</p>
                     <p v-if="orderDetail.collageId==0" class="time fs12 mar-bot-10 font-color-999 flex-items"><img style="width:13px;height:13px;margin-right:5px;" src="../../../static/image/alarm_clock@2x.png" alt=""> 剩余时间{{endTime | formatMinutes}}分</p>
                     <p v-else class="time fs12 mar-bot-10 font-color-999 flex-items"><img style="width:13px;height:13px;margin-right:5px;" src="../../../static/image/alarm_clock@2x.png" alt=""> 剩余时间{{endTime1 | formatMinutes}}分</p>
                     <el-button plain size="small" @click="closeOrder" class="cancel mar-bot-10">取消订单</el-button>
                     <el-button plain size="small" @click="getUrl" class="pay mar-bot-10">付款</el-button>
                </div>
                <div class="box" v-if="orderDetail.state==6 || orderDetail.collageId!=0 && orderDetail.paymentState==1 || orderDetail.collageId!=0 && orderDetail.state==5">
                     <p class="fs24 fw-blod mar-bot-10 font-color-FF7" v-if="orderDetail.paymentState==1 && groupData.state==0">等待成团</p>
                     <p class="fs24 fw-blod mar-bot-10 font-color-FF7" v-if="orderDetail.paymentState==1 && groupData.state==1">拼团成功</p>
                     <p class="fs24 fw-blod mar-bot-10 font-color-red" v-if="orderDetail.state==5 && groupData.state==2">拼团失败</p>
                     <el-button plain size="small" @click="inviteFriends" class="invite mar-bot-10" v-if="orderDetail.paymentState==1 && groupData.state==0">邀请好友</el-button>
                     <el-button plain size="small" @click="closeOrder" class="cancel mar-bot-10" v-if="groupData.state==0">取消订单</el-button>
                     <el-button plain size="small" @click="again" class="invite" v-if="groupData.state!=0">再次开团</el-button>
                </div>
                 <div class="box mar-top-40" v-if="orderDetail.state==2 && orderDetail.collageId==0">
                     <p class="fs24 fw-blod font-color-FF7">待发货</p>
                 </div>
                 <div class="box mar-top-40" v-if="orderDetail.state==3 && orderDetail.collageId==0">
                     <p class="fs24 fw-blod mar-bot-10 font-color-FF7">运输中</p>
                 </div>
                 <div class="box mar-top-40" v-if="orderDetail.state==4 && orderDetail.collageId==0">
                     <p class="fs24 fw-blod mar-bot-10 font-color-71B">已完成</p>
                 </div>
                 <div class="box mar-top-40" v-if="orderDetail.state==5 && orderDetail.collageId==0">
                     <p class="fs24 fw-blod mar-bot-10 font-color-71B">已关闭</p>
                 </div>
                 <!-- <div v-if="orderDetail.state==6">
                     <p class="fs24 fw-blod mar-bot-10 font-color-FF7">申请退货</p>
                 </div>
                 <div v-if="orderDetail.state==7">
                     <p class="fs24 fw-blod mar-bot-10 font-color-FF7">处理中</p>
                 </div>
                 <div v-if="orderDetail.state==6">
                     <p class="fs24 fw-blod mar-bot-10 font-color-71B">已取消</p>
                 </div>
                 <div v-if="orderDetail.state==8">
                     <p class="fs24 fw-blod mar-bot-10 font-color-71B">已退款</p>
                 </div> -->
              </div>
              <div class="right">
                  <StatusOne :createTime="orderDetail.createTime" v-if="orderDetail.state==1 && orderDetail.collageId==0"></StatusOne>
                  <StatusTwo :createTime="orderDetail.createTime" v-if="orderDetail.state==2 && orderDetail.collageId==0"></StatusTwo>
                  <StatusThree :createTime="orderDetail.createTime" v-if="orderDetail.state==3 && orderDetail.collageId==0"></StatusThree>
                  <StatusFour :receiveTime="orderDetail.receiveTime" :createTime="orderDetail.createTime" v-if="orderDetail.state==4 && orderDetail.collageId==0"></StatusFour>
                  <StatusFive :createTime="orderDetail.createTime" v-if="orderDetail.state==5 && orderDetail.collageId==0"></StatusFive>
                  <StatusSix :type="6" :createTime="orderDetail.createTime" v-if="orderDetail.state==6 && orderDetail.collageId!=0"></StatusSix>
                  <StatusSix :type="1" :createTime="orderDetail.createTime" v-if="orderDetail.state==1 && orderDetail.collageId!=0"></StatusSix>
                  <StatusSix :type="2" :createTime="orderDetail.createTime" v-if="orderDetail.state==2 && orderDetail.collageId!=0"></StatusSix>
                  <StatusSix :type="3" :createTime="orderDetail.createTime" v-if="orderDetail.state==3 && orderDetail.collageId!=0"></StatusSix>
                  <StatusSix :receiveTime="orderDetail.receiveTime" :type="4" :createTime="orderDetail.createTime" v-if="orderDetail.state==4 && orderDetail.collageId!=0"></StatusSix>
                  <StatusSix :type="5" :createTime="orderDetail.createTime" v-if="orderDetail.state==5 && orderDetail.collageId!=0"></StatusSix>
              </div>
          </div>
<!--          拼单信息-->
          <div class="groupBuying" v-if="orderDetail.collageId!=0 && orderDetail.state!=1">
            <div class="groupBuyTit">拼团信息</div>
            <div class="groupBuyBox">
<!--              <div class="result">未能按时成团，拼团失败</div>-->
              <div class="result" v-if="groupData.state==0">付款成功，待成团</div>
              <div class="result" v-if="groupData.state==1">恭喜您拼团成功</div>
              <div class="result0 mar-bot-20 fs18" v-if="groupData.state==2">未能按时成团，拼团失败</div>
              <p v-if="groupData.state==0">{{ groupData.person }}人团，离拼团成功还差<span>{{ groupData.people }}</span>人</p>
              <div class="surplusTime" v-if="groupData.state==0">剩余时间：<span class="day time">{{groupData.time | formatHours}}</span>时<span class="time">{{groupData.time | formatMinutes}}</span>分<span class="time">{{groupData.time | formatSeconds}}</span>秒</div>
              <div class="userList">
                <span v-for="(item,index) of groupData.personList" :key="item.id">
                  <i v-if="index === 0">团长</i>
                  <img :src="item.headImage" alt="">
                </span>
                <span class="noPeople iconfont" v-for="index of groupData.people" :key="index + 'n'">
                  &#xe64b;
                </span>
              </div>
            </div>
          </div>
          <div class="logistics" v-if="orderDetail.state===3 || orderDetail.state===4">
              <p class="fs16 font-color-333">物流信息</p>
              <div class="content">
                  <div class="left">
                      <img src="../../../static/image/wuliuxin@2x.png" alt="">
                      <div>
                          <p>发货方式：快递</p>
                          <p>物流公司：{{orderDetail.express}}</p>
                          <p>运单号码：{{orderDetail.deliverFormid}}</p>
                      </div>
                  </div>
                  <div class="right">
                      <div class="title">物流跟踪：</div>
                      <div class="dilevery">
                        <el-timeline>
                          <el-timeline-item
                            v-for="(item, index) in dilevery"
                            :key="index"
                            :timestamp="item.time"
                            placement="top">
                            <div v-html="item.reason" style="font-size: 14px;color: #666;"></div>
                          </el-timeline-item>
                        </el-timeline>
                          <!-- <div v-for="(item, index) in dilevery" :key="index" :class="index==0?'active':''">
                              <span class="dot">
                                  <span class="line"></span>
                              </span>
                              <p>{{item.time}}&emsp;{{item.reason}}</p>
                          </div> -->
                          <!-- <el-steps direction="vertical" :active="1" space="100">
                            <el-step :title="item.time+'：'+item.reason" v-for="(item, index) in dilevery" :key="index"></el-step>
                          </el-steps> -->
                      </div>
                  </div>
              </div>
          </div>
          <div class="desc">
              <div class="receivingInfo">
                  <p class="title">收货信息</p>
                  <div class="info">
                      <p>收货地址：{{orderDetail.receiveAdress}}{{orderDetail.address}}</p>
                      <p>收货人：{{orderDetail.receiveName}}</p>
                      <p>收货电话：{{orderDetail.receivePhone}}</p>
                  </div>
              </div>
              <div class="storeInfo">
                  <p class="title">卖家信息</p>
                  <div class="info">
                      <p>店铺名称：{{orderDetail.shopName}}</p>
                      <p>联系电话：{{orderDetail.chargePersonPhone}}</p>
                  </div>
              </div>
              <div class="orderInfo">
                  <p class="title">订单信息</p>
                  <div class="info">
                      <p>订单号：{{orderDetail.orderFormid}}</p>
                      <p v-if="orderDetail.paymentState==1">支付渠道：{{orderDetail.paymentMode}}</p>
                      <p v-if="orderDetail.paymentState==1">交易号：{{orderDetail.transactionId}}</p>
                      <p>创建时间：{{orderDetail.createTime}}</p>
                      <p v-if="orderDetail.paymentState==1">付款时间：{{orderDetail.paymentTime}}</p>
                      <p v-if="orderDetail.state==4">成交时间：{{orderDetail.receiveTime}}</p>
                      <p>备注：{{orderDetail.remark}}</p>
                  </div>
              </div>
              <div class="productInfo">
                  <div class="top">
                      <span class="big">商品</span>
                      <span>商品属性</span>
                      <span>状态</span>
                      <span>数量</span>
                      <span>单价</span>
                  </div>
                  <div class="bottom" v-for="(pro, idx) in orderDetail.skus" :key="idx">
                      <div class="big">
                          <img :src="pro.image" alt="">
                          <p>{{pro.productName}}</p>
                      </div>
                      <div style="flex-direction: column;">
                          <p v-for="(text, ins) in pro.values" :key="ins">{{text}}</p>
                      </div>
                      <div v-if="orderDetail.state==1">待付款</div>
                      <div v-if="orderDetail.state==2">待发货</div>
                      <div v-if="orderDetail.state==3">待收货</div>
                      <div v-if="orderDetail.state==4">已完成</div>
                      <div v-if="orderDetail.state==5">已关闭</div>
                      <div v-if="orderDetail.state==6">待成团</div>
                      <div>{{pro.number}}</div>
                      <div class="font-color-FF7 fs-bold">¥{{pro.price}}</div>
                  </div>
              </div>
              <div class="settlement">
                  <div class="box">
                      <div class="left">
                          <p>商品总价：<span class="right" style="color:#FF7800;">¥{{orderDetail.orderPrice }}</span></p>
                          <p>运费：<span class="right">¥{{orderDetail.logisticsPrice}}</span></p>
                          <p>平台优惠：<span class="right">-¥{{orderDetail.discountPrice}}</span></p>
                          <p v-if="orderDetail.paymentState==0" class="mar-top-20">需付款：<span class="right mar-top-20" style="color:#FF7800;">¥{{orderDetail.price}}</span></p>
                          <p v-if="orderDetail.paymentState==1" class="mar-top-20">实付款：<span class="right" style="color:#FF7800;">¥{{orderDetail.price}}</span></p>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    <el-dialog
      title="提示"
      :visible.sync="closeOrderDialog"
      width="30%"
      :before-close="closeOrderBtn">
      <span>是否取消该订单?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeOrderDialog = false">取 消</el-button>
        <el-button type="primary" @click="cancelOrder">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="inviteDialog"
      width="30%"
      :before-close="inviteDialogClose">
      <div class="inviteDialog">
        <div class="inviteTit">邀请好友</div>
        <div class="imgCode">
          <img :src="share.qrcode" alt="">
        </div>
        <!-- <p>扫描下方二维码或复制链接分享给好友吧</p>
        <div class="linkBox">
          <span class="linkAddress">www.1234567.com</span>
          <span class="copyBtn">复制</span>
        </div> -->
      </div>
    </el-dialog>
    <el-dialog
      class="weChat"
      
      :visible.sync="weChatDialog"
      :before-close="handleClose"
      center
      width="25%">
      <div class="weChatBox">
        <div style="font-size:18px;color:#000000;padding:0 20px;">
          请使用具有扫码支付功能的APP完成支付（支持微信、支付宝、云闪付等APP）
        </div>
        <div style="font-size:32px;color:#000000;width:100%;text-align:center;">￥{{payInfo.money}}</div>
        <div class="qCode">
          <img :src="payInfo.url" alt="">
          <img src="../../assets/images/weiXintit.png" alt="">
        </div>
        <div class="weChatInfo">
          <img src="../../assets/images/imgPay.png" alt="">
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import StatusOne from '../../components/status/statusOne'
import StatusTwo from '../../components/status/statusTwo'
import StatusThree from '../../components/status/statusThree'
import StatusFour from '../../components/status/statusFour'
import StatusFive from '../../components/status/statusFive'
import StatusSix from '../../components/status/statusSix'
import api from '../../api'
import {listSearchMixin} from '../../config/mixin'
import { mapGetters, mapMutations } from "vuex";
export default {
  mixins: [listSearchMixin],
    components: {
        StatusOne,
        StatusTwo,
        StatusThree,
        StatusFour,
        StatusFive,
        StatusSix
    },
    data () {
        return {
          orderDetail: {},
          value: '',
          values: '',
          textarea: '',
          textarea1: '',
          text: '',
          dialogImageUrl: '',
          dialogVisible: false,
          disabled: false,
          orderId: '',
          dilevery: [],
          endTime: '',
          closeOrderDialog: false,
          inviteDialog: false,
          share: {},
          groupData: {},
          setTime: null,
          endTime1: '',
          noticeId: '',
          weChatDialog: false,
          payInfo: {},
          chatTimer: null
        }
    },
    filters: {
      formatHours: function (value) {
        let hours = Math.floor(value / (1000 * 60 * 60))
        if (hours < 10) {
          return '0' + hours
        } else {
          return hours
        }
      },
      formatMinutes: function (value) {
        let minutes = Math.floor((value % (1000 * 60 * 60)) / (1000 * 60))
        if (minutes < 10) {
          return '0' + minutes
        } else {
          return minutes
        }
      },
      formatSeconds: function (value) {
        let seconds = Math.round((value % (1000 * 60)) / 1000)
        if (seconds < 10) {
          return '0' + seconds
        } else {
          return seconds
        }
      }
    },
    created () {
        this.orderId = this.$route.query.orderId
        if (this.$route.query.noticeId) {
          this.noticeId = this.$route.query.noticeId
        }
    },
    mounted () {
        this.getOrderDetail()
    },
    destroyed () {
      clearInterval(this.setTime)
    },
    computed: {
    ...mapGetters([
      "userInfo", // 用户信息
    ]),
    
  },
    methods: {
        ...mapMutations({
          setUserInfo: 'SET_USERINFO'
        }),
        // 获取用户信息
    getUserInfo() {
      let self = this;
      let params = {
        url: api.getUserInfo,
        method: "post",
        data: {
          buyerUserId: this.userInfo.buyerUserId,
        },
      };
      self.sendReq(params, (res) => {
        
        if (res.code === "200") {
          self.setUserInfo(res.data);
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
        // 倒计时
        countDown () {
          clearInterval(this.setTime)
          this.setTime1 = setInterval(() => {
            if (this.groupData.time >= 1000) {
              this.groupData.time -= 1000
            } else {
              this.groupData.time = 0
              clearInterval(this.setTime)
              window.location.reload()
            }
          }, 1000)
        },
        // 时间戳转分秒
        toHHmmss (date) {
          var timer = ''
          var minutes = parseInt((date % (1000 * 60 * 60)) / (1000 * 60))
          // var seconds = (date % (1000 * 60)) / 1000
          timer = (minutes < 10 ? ('0' + minutes) : minutes) + '分'
          return timer
        },
        // 获取订单详情
        getOrderDetail () {
          const rLoading = this.openLoading()
          let self = this
          let params = {
            url: api.getOrderDetail + '?orderId=' + self.orderId + '&noticeId=' + self.noticeId,
            method: 'GET',
            data: {
            }
          }
          self.sendReq(params, (res) => {
            if (res.code === '200') {
              self.orderDetail = res.data
              self.groupData = res.data.collageDetail
              self.endTime = res.data.time
              self.getDilevery()
              if (self.groupData.time) {
                self.endTime1 = self.groupData.time
              }
              if (self.groupData.time >= 1000 && res.data.state === 6 && self.groupData.state === 0) {
                self.countDown()
              }
              self.getUserInfo()
              rLoading.close()
            } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
          })
        },
        // 查询物流信息
        getDilevery () {
          let self = this
          let params = {
            url: api.getDilevery + `?express=${self.orderDetail.express}` + `&deliverFormid=${self.orderDetail.deliverFormid}`,
            method: 'GET',
            data: {
            }
          }
          self.sendReq(params, (res) => {
            if (res.code === '200') {
              // console.log(res)
              self.dilevery = res.data
            } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
          })
        },
        // 取消订单
        cancelOrder () {
            let self = this
            let params = {
              url: api.cancelOrder,
              method: 'PUT',
              data: {
                orderId: self.orderDetail.orderId
              }
            }
            self.sendReq(params, (res) => {
              // console.log(res)
              if (res.code === '200') {
                self.closeOrderDialog = false
                self.getOrderDetail()
              } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
            })
        },
        // 去付款
        // pay () {
        //     let self = this
        //     let params = {
        //         url: api.pay,
        //         method: 'PUT',
        //         data: {
        //           orderId: self.orderDetail.orderId,
        //           type: 2,
        //           money: self.orderDetail.price
        //         }
        //     }
        //     self.sendReq(params, (res) => {
        //       if (res.code === '200') {
        //          self.getOrderDetail()
        //       } else {
        //         self.$message({
        //             message: res.message,
        //             type: 'warning'
        //         })
        //       }
        //     })
        // },
        handleRemove (file) {
          // console.log(file)
        },
        handlePictureCardPreview (file) {
          this.dialogImageUrl = file.url
          this.dialogVisible = true
        },
        handleDownload (file) {
          // console.log(file)
        },
      // 取消订单
      closeOrder () {
          this.closeOrderDialog = true
      },
      // 邀请好友
      inviteFriends () {
        let params = {
          url: api.getShare + `?collageId=${this.orderDetail.collageId}&orderId=${this.orderDetail.orderId}&productId=${this.orderDetail.skus[0].productId}&skuId=${this.orderDetail.skus[0].skuId}&type=0`,
          method: 'GET'
        }
        this.sendReq(params, (res) => {
          if (res.code === '200') {
            this.share = res.data
          }
        })
          this.inviteDialog = true
      },
      closeOrderBtn () {
          this.closeOrderDialog = false
      },
      inviteDialogClose () {
          this.inviteDialog = false
      },
      // 再次开团
      again () {
        let data = {
          shopId: this.orderDetail.shopId,
          productId: this.orderDetail.skus[0].productId,
          skuId: this.orderDetail.skus[0].skuId
        }
        this.$router.push({
          path: '/productDetail',
          query: {
            proData: JSON.stringify(data)
          }
        })
      },
      // 付款
      getUrl () {
        let self = this
        let params = {
          url: api.getPayCode,
          method: 'GET',
          payload: {
            orderId: self.orderDetail.orderId
          }
        }
        self.sendReq(params, (res) => {
          if (res.code === '200') {
            self.payInfo = res.data
            self.weChatDialog = true
            self.chatTimer = setInterval(() => {
              self.checkPay(res.data)
            }, 3000)
          } else {
            self.$message({
              message: res.message,
              type: 'error'
            })
          }
        })
      },
      // 取消支付
      handleClose () {
        // this.$confirm('确认取消支付？')
        //   .then(_ => {
        //     clearInterval(this.chatTimer)
        //     this.weChatDialog = false
        //   })
        //   .catch(_ => {})
        let _this = this
        this.$confirm({
          okText:'确定',
          cancelText:'取消',
          title: '取消支付',
          content: '确认取消支付？',
          onOk() {
            clearInterval(_this.chatTimer)
            _this.weChatDialog = false
          },
          onCancel() {},
        });
      },
      checkPay (paramsData) {
        setTimeout(() => {
          let self = this
          let params = {
            url: api.checkPay + `?collageId=${paramsData.collageId}&money=${paramsData.money}&orderId=${paramsData.orderId}&type=2`,
            method: 'GET'
          }
          self.sendReq(params, (res) => {
            if (res.code === '200') {
              if (res.data.code === 'SUCCESS') {
                self.$message({
                  message: '支付成功！',
                  type: 'success'
                })
                clearInterval(self.chatTimer)
                self.weChatDialog = false
                self.getOrderDetail()
              }
            } else {
              clearInterval(self.chatTimer)
              self.$message({
                message: res.message,
                type: 'error'
              })
              self.weChatDialog = false
            }
          })
        }, 0)
      }
    }
}
</script>
<style lang="scss">
  .main{
    background: #f5f5f5;
  }
</style>
<style lang="scss" scoped>
.orderDetail{
    width: 100%;
    .banxin{
        background: #FFFFFF;
        width: 1252px;
        margin: 27px auto;
        padding: 0 27px 27px 27px;
        .head {
            width: 100%;
            height: 50px;
            line-height: 50px;
            font-size: 16px;
            display: flex;
            align-items: center;
            .arrow {
                background-image: url('../../../static/image/xiangyou@2x.png');
                width: 5px;
                height: 10px;
                margin-right: 10px;
            }
        }
        .status{
            width: 100%;
            height: 325px;
            border: 1px solid #E5E5E5;
            box-sizing: border-box;
            padding: 15px;
            display: flex;
            margin-bottom: 20px;
            .left{
                flex: 1;
                border-right: 1px solid #E5E5E5;
                display: flex;
                align-items: center;
                flex-direction: column;
                .cancel{
                    width: 100px;
                    margin-left: 0;
                }
                .invite{
                  width: 100px;
                  border: 1px solid #FF7800;
                  color: #FF7800;
                }
                .pay{
                    width: 100px;
                    border-color: #FF7800;
                    color: #FF7800;
                    margin-left: 0;
                }
                .pay:hover{
                    background-color: rgba($color: #FF7800, $alpha: 0.3);
                }
                .box{
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }
              .groupShopping {
                .groupShopTit {
                  font-size: 24px;
                  font-weight: bold;
                  color: $mainColor;
                  margin-bottom: 18px;
                }
                span {
                  width: 100px;
                  height: 30px;
                  line-height: 30px;
                  border: 1px solid #FF7800;
                  border-radius: 4px;
                  color: $mainColor;
                  font-size: 14px;
                  display: block;
                  text-align: center;
                  margin-bottom: 12px;
                  cursor: pointer;
                }
                .closeOrder {
                  font-size: 14px;
                  color: #999999;
                  border: 1px solid #999999;
                }
              }
            }
            .right{
                flex: 3;
                padding: 20px;
                box-sizing: border-box;
            }
        }
        .logistics{
            padding: 25px;
            width: 100%;
            box-sizing: border-box;
            margin-bottom: 20px;
            border: 1px solid #E5E5E5;
            .content{
                display: flex;
                .left{
                    padding: 20px 0;
                    flex: 2;
                    display: flex;
                    align-items: center;
                    box-sizing: border-box;
                    border-right: 2px solid #E5E5E5;
                    img{
                        width: 200px;
                        height: 200px;
                        margin-right: 40px;
                    }
                    div{
                        p{
                            font-size: 14px;
                            color: #666666;
                            margin-bottom: 20px;
                        }
                    }
                }
                .right{
                    flex: 3;
                    padding: 20px;
                    box-sizing: border-box;
                    display: flex;
                    .dilevery{
                        height: 280px;
                        width: 600px;
                        overflow-x: auto;
                        padding: 20px;
                        box-sizing: border-box;
                        // div{
                        //     padding-left: 25px;
                        //     margin-bottom: 25px;
                        //     position: relative;
                        //     box-sizing: border-box;
                        //     white-space: nowrap;
                        //     .dot{
                        //         // display: inline-block;
                        //         width: 6px;
                        //         height: 6px;
                        //         border-radius: 3px;
                        //         background-color: #D9D9D9;
                        //         margin-right: 10px;
                        //         position: absolute;
                        //         left: 0;
                        //         top: 50%;
                        //         transform: translate(50%,0);
                        //         .line{
                        //             position: absolute;
                        //             left: 50%;
                        //             top: 12px;
                        //             transform: translate(-50%,0);
                        //             width: 2px;
                        //             height: 25px;
                        //             background-color: #F1F1F1;
                        //         }
                        //     }
                            // .line{
                            //     width: 100%;
                            //     border-left: 2px solid #F1F1F1;
                            //     height: 25px;
                            //     margin-left: -21px;
                            // }
                        // }
                        // div:last-child{
                        //     margin-bottom: 0;
                        //     .line{
                        //         display: none;
                        //     }
                        // }
                        // .active{
                        //     .dot{
                        //         background-color: #FF7800;
                        //     }
                        // }
                    }
                }
            }
        }
        .desc{
            width: 100%;
            border: 1px solid #E5E5E5;
            margin-bottom: 140px;
            .receivingInfo,.storeInfo,.orderInfo{
                padding: 25px;
                border-bottom: 1px solid #E5E5E5;
                .title{
                    font-size: 16px;
                    margin-bottom: 25px;
                }
                .info{
                    display: flex;
                    margin-left: 75px;
                    flex-wrap: wrap;
                    p{
                        line-height: 30px;
                        width: 50%;
                        font-size: 14px;
                    }
                }
            }
            .orderInfo,.receivingInfo{
                .info{
                    p{
                        width: 33.33%;
                    }
                }
            }
            .productInfo{
                width: 100%;
                .top{
                    height: 40px;
                    width: 100%;
                    background-color: #EDEDED;
                    display: flex;
                    align-items: center;
                    text-align: center;
                    span{
                        flex: 1;
                        font-size: 12px;
                    }
                    .big{
                        flex: 2;
                    }
                }
                .bottom{
                    width: 100%;
                    padding: 20px 0;
                    box-sizing: border-box;
                    text-align: center;
                    display: flex;
                    border-bottom: 1px solid #E5E5E5;
                    div{
                        flex: 1;
                        font-size: 14px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        p{
                            font-size: 14px;
                            line-height: 20px;
                        }
                    }
                    .big{
                        text-align: left;
                        flex: 2;
                        display: flex;
                        box-sizing: border-box;
                        justify-content: flex-start;
                        align-items: center;
                        img{
                            width: 80px;
                            height: 80px;
                            margin: 0 20px;
                        }
                        p{
                            width: 50%;
                        }
                    }
                }
            }
            .settlement{
                width: 100%;
                display: flex;
                padding: 25px;
                box-sizing: border-box;
                justify-content: flex-end;
                .box{
                    display: flex;
                    .left{
                        text-align: right;
                        p{
                            width: 250px;
                            display: flex;
                            justify-content: space-between;
                            font-size: 20px;
                            color: #666666;
                            line-height: 30px;
                        }
                        .right{
                            text-align: right;
                            margin-left: 40px;
                        }
                    }
                }
            }
        }
    }
  .groupBuying {
    border: 1px solid #E5E5E5;
    height: 325px;
    padding: 20px;
    margin-bottom: 20px;
    .groupBuyTit {
      font-size: 16px;
      color: #333333;
      font-weight: bold;
    }
    .groupBuyBox {
      text-align: center;
      margin-top: 30px;
      .result {
        font-size: 18px;
        margin-bottom: 20px;
      }
      .result0 {
        color: #EC4B42;
      }
      p {
        font-size: 14px;
        color: #333333;
        margin-bottom: 20px;
        span {
          color: #FF7800;
          font-size: 14px;
          font-weight: normal;
        }
      }
      .surplusTime {
        margin-bottom: 30px;
        font-size: 16px;
        color: #666666;
        display: flex;
        justify-content: center;
        align-items: center;
        .day {
          margin-left: 10px;
        }
        .time {
          color: #FF7800;
        }
        span {
          border: 1px solid #E5E5E5;
          border-radius: 2px;
          display: block;
          width: 24px;
          height: 24px;
          text-align: center;
          line-height: 20px;
          margin:0 8px;
        }
      }
      .userList {
        display: flex;
        justify-content: center;
        align-items: center;
        span {
          display: block;
          width: 76px;
          height: 76px;
          position: relative;
          margin: 0 13px;
          border-radius: 50%;
          box-sizing: border-box;
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
          i {
            position: absolute;
            left: 8px;
            bottom: -10px;
            width: 60px;
            height: 24px;
            background: $mainColor;
            border-radius: 12px;
            font-style: normal;
            text-align: center;
            line-height: 24px;
            color: #FFFFFF;
            font-size: 14px;
          }
        }
        .noPeople {
          border: 1px dashed #E5E5E5;
          color: #DBDBDB;
          font-size: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        span:first-child {
          border: 1px solid $mainColor;
        }
      }
    }
  }
  .inviteDialog {
    text-align: center;
    .inviteTit {
      font-size: 22px;
      color: #444444;
    }
    .imgCode {
      width: 200px;
      height: 200px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    p {
      margin: 25px 0;
    }
    .linkBox {
      display: flex;
      justify-content: center;
      .linkAddress {
        height: 40px;
        line-height: 40px;
        padding: 0 20px;
        display: block;
        width: 220px;
        text-align: left;
        border: 1px solid #E5E5E5;
      }
      .copyBtn {
        width: 100px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #FFFFFF;
        border: 1px solid $mainColor;
        color: $mainColor;
        margin-left: 20px;
        cursor: pointer;
      }
    }
  }
  .weChatBox {
    // display: flex;
    text-align: center;
    img {
      width: 100%;
    }
    .qCode {
      width: 100%;
      text-align: center;
      img {
        width: 80%;
      }
    }
    .weChatInfo {
      width: 50%;
    }
  }
  .weChat {
    >>> .el-dialog__body {
      background: #FFFFFF;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/orderDetail/index.vue